<template>
  <div class="permissionManage">
    <OADrag col="6">
      <OACard header="组织架构">
        <el-input ref="departInput" id="btn" placeholder="请输入部门进行查询" v-model="filterText"></el-input>
        <el-tree
          ref="depart"
          :data="departData"
          node-key="id"
          :props="departProps"
          accordion
          :filter-node-method="filterNode"
          :default-expanded-keys="firstData"
          highlight-current
          @node-click="getPost"
        ></el-tree>
      </OACard>
    </OADrag>
    <OADrag col="4">
      <OACard header="职位内职位">
        <div v-if="!positionData.length" class="empty">暂无数据</div>
        <ul class="content-body">
          <li
            v-for="item in positionData"
            :key="item.id"
            @click.left="changePosition(item)"
            :class="{'active':item.id==positionId}"
          >
            {{item.positionName}}
            <i
              class="el-icon-document-copy pull-right"
              @click="sync(item.positionId)"
            ></i>
          </li>
        </ul>
      </OACard>
      <OACard header="职位内人员">
        <div v-if="!personnelData.length" class="empty">暂无数据</div>
        <ul class="content-body">
          <li v-for="item in personnelData" :key="item.id">{{item}}</li>
        </ul>
      </OACard>
    </OADrag>
    <OADrag col="4">
      <OACard header="应用权限">
        <div v-if="!systemData.length" class="empty">暂无数据</div>
        <ul class="content-body">
          <li
            v-for="item in systemData"
            :key="item.id"
            @click="getPermissionType(item)"
            :class="{'active':item.code==code}"
          >
            <span @click.stop>
              <el-checkbox :label="item.name" v-model="item.checked" @change="appChecked(item)"></el-checkbox>
            </span>
          </li>
        </ul>
      </OACard>
    </OADrag>
    <OADrag col="10">
      <OACard :header="`设置 ${username} 职位权限`">
        <div v-if="!typeData.length" class="empty">暂无数据</div>
        <el-tabs v-model="type" @tab-click="getPer">
          <el-tab-pane
            v-for="(item,index) in typeData"
            :key="item.id"
            :name="item.type"
            :label="item.name"
          >
            <div v-loading="loading">
              <!-- 
              :data="menusData"    展示数据 arr
              show-checkbox     节点是否可被选择 boolean 默认false
              node-key="id"    通过id获取节点
              :props="permissionProps"  配置选项 obj
              default-checked-keys 默认勾选的节点的 key 的数组
              accordion  是否每次只打开一个同级树节点展开
              highlight-current  是否高亮当前选中节点，默认值是 false。
              check-strictly  在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false
              check-change  节点选中状态发生变化时的回调  
              共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、
              节点本身是否被选中、节点的子树中是否有被选中的节点
               -->
              <el-tree
                ref="menusData"
                v-if="item.frameType==0"
                :data="menusData"
                show-checkbox
                node-key="id"
                :props="permissionProps"
                :default-checked-keys="checkList"   
                accordion
                check-strictly
                highlight-current
                @check-change="setChecked"
              ></el-tree>
              <ul class="duty" v-else-if="item.frameType==1">
                <li v-for="item in menusData" :key="item.id">
                  {{item.name}}
                  <el-checkbox v-model="item.check" @change="dutyChecked(item)"></el-checkbox>
                </li>
              </ul>
              <ul v-else class="business">
                <el-checkbox
                  v-for="item in menusData"
                  :key="item.id"
                  v-model="item.check"
                  :label="item.name"
                  border
                  size="medium"
                  @change="dutyChecked(item)"
                ></el-checkbox>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </OACard>
    </OADrag>

    <OAModalForm
      title="将本职位的权限复制给..."
      :visible.sync="dialogVisible"
      :form-data="formData"
      @on-submit="submit"
      :saving="syncLoading"
      @on-cancel="dialogVisible=false"
    ></OAModalForm>
  </div>
</template>
<script>
import OADrag from "@/components/OADrag/OADrag";
import OACard from "@/components/OACard/OACard";
import OATree from "@/components/OATree/OATree";
import { Json2Tree, resFilter } from "@/common/util.js";
import permissionApi from "@/services/permission.js";
import commonApi from "@/services/common.js";
import store from "@/store";
import OAModalForm from "@/components/OAModalForm/OAModalForm";

export default {
  name: "permissionManage",
  components: { OADrag, OACard, OATree, OAModalForm },
  data() {
    return {
      syncLoading: false, // 同步权限表单弹窗loading
      username: "", //设置的用户权限
      filterText: "",
      firstData: [], //默认展开子集
      departmentId: "", //部门id
      positionId: "", //职位id
      type: "125000",
      departProps: {
        children: "children",
        label: "departName"
      },
      permissionProps: {
        children: "children",
        label: "name"
      },
      departData: [], //部门数据
      positionData: [], //职位列表数据
      personnelData: [], //人员列表数据
      systemData: [], //应用数据
      typeData: [], //权限类型数据
      menusData: [], //应用菜单数据
      postId: "",
      code: "",
      checkList: [],
      dialogVisible: false,
      loading: false,
      formData: {
        departmentIds: {
          formType: "a-depart-cascader",
          options: [],
          value: [],
          placeholder: "请选择部门",
          label: "所属部门：",
          change: (formData, item) => {
            formData.positionId.departId = _.last(item.value);
          },
          rules: [{ required: true, message: "请选择部门", trigger: "change" }]
        },
        positionId: {
          formType: "a-post-select",
          departId: "",
          value: "",
          placeholder: "请选择职位",
          label: "职位名称：",
          rules: [{ required: true, message: "请选择职位", trigger: "change" }]
        }
      }
    };
  },
  mounted() {
    let vm = this;
    this.getAllDepart();
    this.$refs.departInput.$refs.input.onclick = function() {
      btn.focus();
    };
  },
  watch: {
    filterText(val) {
      if (val != "") {
        this.$refs.depart.filter(val);
      } else {
        this.getAllDepart();
      }
    }
  },
  methods: {
    sync(val) {
      this.dialogVisible = true;
      this.positionId = val;
    },
    async submit(val) {
      this.syncLoading = true;
      let res = await permissionApi.syncPost2({
        firstPosition: this.positionId,
        secondPosition: val.positionId
      });
      this.syncLoading = false;
      resFilter(res);
      this.dialogVisible = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.departName.indexOf(value) !== -1;
    },
    async getAllDepart() {
      let res = await commonApi.getAllDepart();
      this.departData = Json2Tree(res.data.data);
      this.firstData = [this.departData[0].id];
    },
    //点击部门树节点获取职位
    async getPost(data) {
      let departId = data.id;
      let res = await commonApi.getPostByDepartId({
        departmentId: departId
      });
      this.positionData = res.data.data;
      this.menusData = [];
      this.typeData = [];
      this.systemData = [];
      this.personnelData = [];
    },
    //点击职位获取人员
    changePosition(item, index) {
      let id = item.id;
      this.positionId = id;
      this.username = item.positionName;
      this.menusData = [];
      this.typeData = [];
      this.getPersonnel(id);
      this.getSystem();
    },
    //获取人员数据
    async getPersonnel(id) {
      let res = await commonApi.getPersonByPostId({ positionId: id });
      this.personnelData = res.data.data;
    },
    //获取应用数据
    async getSystem() {
      this.code = 0;
      let res = await permissionApi.getSystem({
        positionId: this.positionId
      });
      this.systemData = res.data.data;
    },
    //获取应用权限数据
    async getPermissionType(data) {
      this.code = data.code;
      let res = await permissionApi.getPermissionType({
        code: data.code
      });
      this.typeData = res.data.data;
      this.type =
        res.data.data && res.data.data.length ? res.data.data[0].type : "0";
      this.getPermission();
    },
    getPer(data) {
      this.loading = true;
      this.menusData = [];
      if (data.index == 0) {
        this.getPermission().then(() => {
          this.loading = false;
        });
      } else {
        this.getPermissionData(data).then(() => {
          this.loading = false;
        });
      }
    },
    //获取操作权限数据
    async getPermission() {
      let res = await permissionApi.getPermission({
        code: this.code,
        positionId: this.positionId
      });
      let data = res.data.data;
      let result = _.filter(data, "checked");
      this.checkList = _.map(result, item => item.id);
      let parentId = _.find(res.data.data, { parentId: "0" }).id;
      this.menusData = Json2Tree(res.data.data, parentId);
    },
    //获取其他权限数据
    async getPermissionData(data) {
      let res = await permissionApi.getPermissionData({
        code: this.code,
        positionId: this.positionId,
        type: data.name
      });
      if (this.typeData[data.index].frameType == 0) {
        let data = res.data.data;
        let result = _.filter(data, "check");
        this.checkList = _.map(result, item => item.id);
        this.menusData = Json2Tree(res.data.data, "0");
      } else {
        this.menusData = res.data.data;
      }
    },
    //设置应用权限
    async appChecked(data) {
      let param = {
        checked: data.checked,
        permissionId: data.id,
        positionId: this.positionId
      };
      let res = await permissionApi.setAppPermission(param);
      resFilter(res, this.getPermissionType(data));
      // this.systemReset();
    },
    //设置权限
    async setChecked(data, checked) {
      data.check = checked;
      if (this.type == "125004") {
        this.dutyChecked(data);
      } else {
        this.menusChecked(data);
      }
    },
    //设置菜单权限
    async menusChecked(data) {
      let param = {
        code: this.code,
        positionId: this.positionId,
        permissionId: data.id,
        checked: data.check
      };
      let res = await permissionApi.setMenusPermission(param);
      resFilter(res);
    },
    //设置其他权限
    async dutyChecked(data) {
      let param = {
        checked: data.check,
        permissionId: data.id,
        positionId: this.positionId,
        type: data.type,
        code: this.code
      };
      let res = await permissionApi.setDataPermission(param);
      resFilter(res);
    }
  }
};
</script>
<style lang="scss">
.permissionManage {
  display: flex;
  .el-input {
    margin-bottom: 10px;
  }
  .el-tree {
    position: static;
    .el-tree-node__content {
      line-height: 38px;
      height: 38px;
    }
  }
  &:last-child {
    margin-right: -10px;
  }
  .el-tabs {
    margin: 0px 15px 15px;
    .el-tree {
      margin-top: 15px;
    }
    .el-tabs__header {
      margin: 0px;
    }
    .el-tabs__content .el-loading-parent--relative {
      min-height: 300px;
    }
    .el-tabs__nav-wrap::after {
      height: 0;
    }
  }
  .duty {
    margin: 20px 20px;
    li {
      border: 1px solid #99befa;
      background: #fafafa;
      padding: 10px 20px;
      margin: 10px 0;
      cursor: pointer;
      .el-checkbox {
        float: right;
      }
    }
  }
  .business {
    .el-checkbox {
      margin: 5px;
    }
  }
  .el-icon-setting {
    font-size: 18px;
    &:hover {
      color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/set/permissionManage.vue